import React, { useMemo } from 'react';
import {
	EntryKeys,
	ENTRYPOINT_ID_JIRA_PLATFORM,
} from '@atlassian/jira-feedback-collector/src/constants.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { FeedbackButton } from '@atlassian/jira-navigation-apps-sidebar-common/src/ui/feedback-button/main.tsx';
import { HelpPanelButton } from '@atlassian/jira-navigation-apps-sidebar-common/src/ui/help-panel-button/main.tsx';
import { ProjectFooter } from '@atlassian/jira-navigation-apps-sidebar-common/src/ui/project-footer/main.tsx';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { useIsAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-admin/index.tsx';
import { useIsAnonymous } from '@atlassian/jira-tenant-context-controller/src/components/is-anonymous/index.tsx';
import { Link } from '@atlassian/react-resource-router';
import { NG_COMMUNITY_LINK } from '../../../common/constants.tsx';
import { messages as commonMessages } from '../../../common/messages.tsx';
import { messages } from './messages.tsx';
import type { Props } from './types.tsx';

export const Footer = ({ isSimplified }: Props) => {
	const { formatMessage } = useIntl();
	const isAdmin = useIsAdmin();
	const isAnonymous = useIsAnonymous();
	const cloudId = useCloudId();

	const showDescription = !isAnonymous && isSimplified;
	const title = messages.titleTeamManaged;
	const feedbackDialogAttributes = useMemo(() => {
		const additionalFields = [
			{ id: EntryKeys.IS_ADMIN, value: String(isAdmin) },
			{ id: EntryKeys.CLOUD_ID, value: cloudId },
			{
				id: EntryKeys.IS_SIMPLIFIED_PROJECT,
				value: String(isSimplified),
			},
		];
		return {
			entrypointId: ENTRYPOINT_ID_JIRA_PLATFORM,
			feedbackGroupId: 'jira-servicedesk-next-gen-sidebar-nav',
			feedbackContext: additionalFields,
			additionalFields,
		};
	}, [isAdmin, cloudId, isSimplified]);

	return (
		<ProjectFooter
			description={
				showDescription && (
					<>
						<FeedbackButton feedbackDialogAttributes={feedbackDialogAttributes} />
						<HelpPanelButton
							articleId="322DvJroFxRchFjLrpSETA"
							aria-label={formatMessage(commonMessages.learnMoreAriaLabel)}
							fallbackComponent={
								<Link
									href={NG_COMMUNITY_LINK}
									target="_blank"
									aria-label={formatMessage(commonMessages.learnMoreAriaLabel)}
								>
									{formatMessage(commonMessages.learnMore)}
								</Link>
							}
						>
							{formatMessage(commonMessages.learnMore)}
						</HelpPanelButton>
					</>
				)
			}
		>
			{isSimplified ? formatMessage(title) : formatMessage(messages.companyManagedTitle)}
		</ProjectFooter>
	);
};
